<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">教案详情</span>
        </div>
        <div class="main cardBg">
            <div class="left">
                <img v-show="tabType"
                     :src="practice.drawingThumbnail ?
                    ((typeof practice.drawingThumbnail == 'string')  ? practice.drawingThumbnail : practice.drawingThumbnail[practice.drawingThumbnail.length-1])
                     : require('@/assets/img/updateImg/exerciseBg.png')"
                     alt="">
                <video v-show="!tabType" id="myVideo" ref="myPlayer" :src="videoSrc"
                       :controls="false"  allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></video>
                <p class="tab" v-if="practice.videoUrl"><span class="tabImg" :class="tabType ? 'check' : ''">图片</span><span class="tabAnimate" :class="tabType ? '' : 'check'">动画</span></p>
            </div>
            <div class="right">
                <h2 class="main__right__title">{{practice.title}}</h2>
                <p class="main__right__val PingFangMedium">{{$global.formatDate(new Date(practice.createTime), 'yyyy/MM/dd HH:mm:ss', true)}}</p>
                <h4 class="main__right__title">标签</h4>
                <div class="main__right__val PingFangMedium">
                    <span class="img__wrapper mr40" style="line-height: 25px;">
                        <i class="icon-user"></i>
                        {{labelVal(practice.tags)}}
                    </span>
                </div>
                <h4  class="main__right__title">目标</h4>
                <p class="main__right__val PingFangMedium" >{{practice.goal}}</p>
                <h4 class="main__right__title">内容</h4>
                <p  class="main__right__val PingFangMedium" ><pre>{{practice.desc}}</pre></p>
            </div>
            <div style="clear: both"></div>
        </div>
    </div>
</template>

<script>
    import { checkboxList, checkboxValues } from '../assets/js/practice/data.js'
    export default {
        name: "lessonDetail",
        data() {
            return {
                practice: {},
                labelList: {

                },
                tabType: true,// true--图片 false--动画
                videoSrc: '',//动画教案url
                checkboxList,
                checkboxValues
            }
        },
        watch: {
            tabType: {
                handler (val, old) {
                    if(!val){
                        this.playVideo();
                    }else {
                        setTimeout(() => {
                            this.tabType = false;
                        }, 2000)
                    }
                },
            }
        },
        created() {
            this.$store.state.pageParams.id = this.$route.query.id;
            this.$store.state.pageParams.page = this.$route.query.page;
            this.$store.state.pageParams.tagsCheck = this.$route.query.tagsCheck;
            this.info()
        },
        methods: {
            info() {
                this.$server.getExerciseDetail({exerciseId: this.$route.query.id})
                .then(res => {
                    this.practice = res.data;
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是教案详情,您请查收！"), true, false)

                    /* 含有逗号的为多选，非含有为单选 */

                    if(this.practice.videoUrl) {
                        this.videoSrc = this.practice.videoUrl;
                        this.$refs.myPlayer.addEventListener('ended', () => { //结束
                            this.tabType = true;
                        }, false);
                        setTimeout(() => {
                            this.tabType = false;
                        }, 2000)
                    }
                })

            },
            //教案标签序列化
            labelVal(value, type) {
                console.log(value)
                let labelStr = [];
                if(value && value.length){
                    value.map(item => {
                        labelStr.push(item.name)
                    })
                }
                return labelStr.join('/')
            },

            //全屏播放视频
            playVideo() {
                this.$refs.myPlayer.currentTime = 0;
                setTimeout(() => {
                    this.$refs.myPlayer.play();
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .cardTit{
        margin-top: 1vw;
        background-image: url("../assets/img/updateImg/head_5.png");
        text-align: left;
        padding-left: 2vw;
    }
    .main {
      height: calc(100% - 100px);
    }
    .left {
        float: left;
        width: 45%;
        padding: 1vw;
        box-sizing: border-box;
        position: relative;
        height: 100%;
        text-align: center;
        img,video{
            height: 100%;
        }

        .tab{
            width: 10vw;
            background: rgba(34, 34, 34, .5);
            height: 2.5vw;
            border-radius: 1.5vw;
            color: #fff;
            position: absolute;
            left: calc(50% - 5vw);
            bottom: 2vw;
            font-size: 22px;
            span {
                display: inline-block;
                width: calc(50% - .5vw);
                height: 2vw;
                line-height: 2vw;
                text-align: center;
                font-weight: normal;
                margin-top: .25vw;
                margin-left: .25vw;
                margin-right: .25vw;
            }
            .check {
                background: var(--primary-color);
                border-radius: 1.5vw;
            }
        }
    }
    .right{
        float: right;
        width: 55%;
        padding-left: 2vw;
        padding-right: 2vw;
        box-sizing: border-box;
        padding-top: 1.5vw;
        font-family: PingFangMedium;
        height: 100%;
        overflow-y: auto;
        .main__right__title{
            font-size: 24px;
            color: #fff;
            font-weight: normal;
        }
        .main__right__val{
            margin-top: .5vw;
            margin-bottom: 1vw;
            font-size: 22px;
            color: rgba(255, 255, 255, .8);
            i {
                display: inline-block;
                width: 1vw;
                height: 1vw;
                margin-bottom: -3px;
                margin-right: .5vw;
            }

            i.icon-user {
                background: url("../assets/img/updateImg/hot.svg") no-repeat center center;
                background-size: 100% 100%;
            }

        }
        h2{
            font-size: 36px !important;
        }
    }
</style>
